// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ucrs-property__lightbox{padding-top:1.5rem;position:relative}.ucrs-property__lightbox-imageWrapper{border-radius:.3rem;display:inline-block}.ucrs-property__lightbox-image{border-radius:.3rem;max-height:calc(100vh - 7rem);-o-object-fit:contain;object-fit:contain}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
